import styles from "./filter-chips.module.css";

export type DateFilterOption = "recent" | "1month" | "3months" | "custom";

export interface DateRange {
  after?: number; // Unix timestamp
  before?: number; // Unix timestamp
}

interface FilterChipsProps {
  selectedFilter: DateFilterOption;
  onFilterChange: (filter: DateFilterOption, range: DateRange) => void;
  compact?: boolean;
  onPickMonthClick?: () => void; // Callback when "Pick Month" is clicked
}

const FILTER_OPTIONS: { value: DateFilterOption; label: string }[] = [
  { value: "recent", label: "Last 20 activities" },
  { value: "1month", label: "Last 1 Month" },
  { value: "custom", label: "Pick Month" },
];

export function getDateRange(
  filter: DateFilterOption,
  customRange?: DateRange,
): DateRange {
  if (filter === "custom" && customRange) {
    return customRange;
  }

  const now = Date.now();
  const nowSeconds = Math.floor(now / 1000);

  switch (filter) {
    case "recent":
      // No date filtering - returns most recent activities
      return {};
    case "1month":
      return {
        after: Math.floor((now - 30 * 24 * 60 * 60 * 1000) / 1000),
        before: nowSeconds,
      };
    case "3months":
      return {
        after: Math.floor((now - 90 * 24 * 60 * 60 * 1000) / 1000),
        before: nowSeconds,
      };
    default:
      return {};
  }
}

export function FilterChips({
  selectedFilter,
  onFilterChange,
  compact = false,
  onPickMonthClick,
}: FilterChipsProps) {
  const handleChipClick = (filterValue: DateFilterOption) => {
    if (filterValue === "custom") {
      onPickMonthClick?.();
    } else {
      const range = getDateRange(filterValue);
      onFilterChange(filterValue, range);
    }
  };

  return (
    <div className={`${styles.container} ${compact ? styles.compact : ""}`}>
      {FILTER_OPTIONS.map((option) => (
        <button
          key={option.value}
          className={`${styles.chip} ${
            selectedFilter === option.value ? styles.selected : ""
          }`}
          onClick={() => handleChipClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
